import moment from 'moment'

export const fromFilterToDates = (fromFilter: string | null) => {
    const currentDate = moment()
    const formatStr = 'YYYY-MM-DD'
    const currentDateStr = currentDate.format(formatStr)
    switch(fromFilter) {
        case 'today':
            return { from: currentDateStr, to: currentDateStr }
        case '7days':
            return { from: currentDate.subtract(7, 'd').format(formatStr), to: currentDateStr }
        case '30days':
            return { from: currentDate.subtract(30, 'd').format(formatStr), to: currentDateStr }
        case 'thisYear':
            return { from: currentDate.startOf('year').format(formatStr), to: currentDateStr }
        case 'lastYear':
            const lastYear = currentDate.subtract(1, 'y')
            return { from: lastYear.startOf('year').format(formatStr), to: lastYear.endOf('year').format(formatStr) }
        default:
            return null
    }
}
